module.exports = __webpack_public_path__ + "img/39.3e3ff56b.png";